import { useContext } from 'react';

import UserPreferencesContext from '@frolight/context/UserPreferencesProvider';

const useUserPreferences = () => {
  return useContext(UserPreferencesContext);
}

export default useUserPreferences;
